export enum ProgressAction {
    ADD = "ADD",
    REMOVE = "REMOVE"
}

export enum ProgressType {
    PERIOD = "PERIOD",
    CONTACT = "CONTACT",
    INSTITUTION = "INSTITUTION",
    INSURANCE = "INSURANCE"
}